// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_1Gd4t","sessionLeft":"_1uQ9t","side":"_9Ox73"};